import { gql } from '@apollo/client'

const GET_OPERATION = gql`
  query GetOperation($id: ID!) {
    operation(id: $id) {
      id
      name
      status
      application {
        id
        name
      }
      request {
        id
      }
      merchantName
      createdAt
      updatedAt
    }
  }
`

export default GET_OPERATION
